export const webUrl = `${window.location.origin}${process.env.PUBLIC_URL}`

export const apiUrl = process.env.REACT_APP_API ?? `${window.location.origin}/api`

// export const streamingUrl = process.env.REACT_STREAMING_API ?? `${window.location.origin}/api`
export const streamingUrl = process.env.REACT_STREAMING_API ?? "https://streaming.cmp.build4smart.com"
